import FeatureGates from '@atlaskit/feature-gate-js-client';
import { AnalyticsClient } from '../../../../utilities/analytics/analytics-web-client';
import { AidFrontendExperiment } from '../../../../providers/FeatureGates';

type ApplicationData = {
  coreApplication: string;
  experience?: string;
};

// TODO: rename to checkAndActivateDirectSignupExperiment to reflect that this function
// has the side effect of injecting the display param into the URL for control/not-enrolled cohorts.
export const checkDirectSignupExperiment = ({
  applicationData,
  analyticsClient,
}: {
  applicationData?: ApplicationData;
  analyticsClient?: AnalyticsClient;
}) => {
  const experimentKey = AidFrontendExperiment.GHOST_ADVANCED_COBRANDING_DIRECT_SIGNUP;
  try {
    const cohortValue = FeatureGates.getExperimentValue(experimentKey, 'cohort', 'not-enrolled', {
      fireExperimentExposure: false,
    }) as 'variation' | 'control' | 'not-enrolled';

    // Add display param to enforce soft-verification for `control` and `not-enrolled` variations.
    const DISPLAY_VALUE = 'eyJ2ZXJpZmljYXRpb25TdHJhdGVneSI6InNvZnQifQ==';
    const topLevelUrl = new URL(window.location.href);
    let urlMutated = false;

    if (cohortValue !== 'variation') {
      // Inject display into the top-level URL
      topLevelUrl.searchParams.set('display', DISPLAY_VALUE);
      urlMutated = true;

      // Inject display into the continue callback URL if present
      const continueRaw = topLevelUrl.searchParams.get('continue');
      if (continueRaw) {
        const callbackUrl = new URL(continueRaw);
        callbackUrl.searchParams.set('display', DISPLAY_VALUE);
        topLevelUrl.searchParams.set('continue', callbackUrl.toString());
      }
    } else {
      // Strip display from top-level URL if present (e.g. URL shared from a control/not-enrolled session)
      if (topLevelUrl.searchParams.has('display')) {
        topLevelUrl.searchParams.delete('display');
        urlMutated = true;
      }

      // Strip display and createMember from the continue callback URL if present
      const continueRaw = topLevelUrl.searchParams.get('continue');
      if (continueRaw) {
        const callbackUrl = new URL(continueRaw);
        let callbackMutated = false;
        if (callbackUrl.searchParams.has('display')) {
          callbackUrl.searchParams.delete('display');
          callbackMutated = true;
        }
        if (callbackMutated) {
          topLevelUrl.searchParams.set('continue', callbackUrl.toString());
          urlMutated = true;
        }
      }
    }

    if (urlMutated) {
      window.history.replaceState(null, '', topLevelUrl.search);
    }

    FeatureGates.manuallyLogExperimentExposure(experimentKey);

    analyticsClient?.trackingEvent({
      page: 'trello-direct-signup',
      action: 'exposed',
      subject: experimentKey,
      attributes: {
        flagKey: experimentKey,
        group: cohortValue,
        application: applicationData?.coreApplication,
        experience: applicationData?.experience,
      },
    });

    return cohortValue === 'variation';
  } catch (error) {
    analyticsClient?.operationalEvent({
      page: 'trello-direct-signup',
      action: 'failed',
      subject: experimentKey,
      attributes: {
        flagKey: experimentKey,
        application: applicationData?.coreApplication,
        experience: applicationData?.experience,
        errorName: error?.name,
        errorStack: error?.stack,
        errorMessage: error?.message,
        errorCode: error?.code,
      },
    });

    console.error(`Error checking ${experimentKey}`, error);
    return false;
  }
};
